import { render, staticRenderFns } from "./ResumenComponent.vue?vue&type=template&id=24024d11"
import script from "./ResumenComponent.vue?vue&type=script&lang=js"
export * from "./ResumenComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports